module.exports = __webpack_public_path__ + "img/37t.710b18c1.jpg";